import { Box, BoxProps } from 'affiny-ui/src';
import React from 'react';

interface IContainer
  extends Omit<BoxProps, 'color' | 'px' | 'mx' | 'maxWidth' | 'boxSizing'> {
  children?: React.ReactNode;
}

export const Container = ({ children, ...rest }: IContainer) => (
  <Box
    maxWidth={[720, 960, 1120]}
    boxSizing="content-box"
    width="100%"
    px="medium"
    mx="auto"
    {...rest}
  >
    {children}
  </Box>
);
